export default __webpack_public_path__ + "resources/icons/d241-e436.png";